import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IconLibrary } from '@finnairoyj/fcom-ui-styles/enums';
import { BehaviorSubject, combineLatestWith, map, Observable } from 'rxjs';

import { icons } from '@finnairoyj/fcom-ui-styles';

import { IconName } from '@fcom/ui-components/components/icons';

@Component({
  selector: 'fin-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleButtonComponent implements OnInit {
  protected readonly IconLibrary = IconLibrary;
  protected readonly icons = icons;

  @Output()
  toggle = new EventEmitter<string>();

  @Input({ required: true })
  name: string;

  @Input({ required: true })
  icon: IconName;

  @Input({ required: true })
  selected$: Observable<boolean>;

  @Input()
  first = false;

  @Input()
  last = false;

  @Input()
  ariaLabel: string;

  focus$ = new BehaviorSubject<boolean>(false);

  effectiveClass$: Observable<{ [key: string]: boolean }>;

  ngOnInit(): void {
    this.effectiveClass$ = this.focus$.pipe(
      combineLatestWith(this.selected$),
      map(([focused, selected]) => {
        return {
          'white-text': selected,
          'nordic-blue-900-bg': selected,
          'rounded-right-large': this.last,
          'rounded-left-large': this.first,
          'border-right': this.last || focused,
        };
      })
    );
  }

  onToggle(): void {
    this.toggle.emit(this.name);
  }

  onFocus(): void {
    this.focus$.next(true);
  }

  onBlur(): void {
    this.focus$.next(false);
  }
}
